module.exports = __webpack_public_path__ + "static/img/makeDefaultProduct.468097d2.gif";